// extracted by mini-css-extract-plugin
export default {"Month":"gQghN","title-wrap":"fsmmF","title":"Q6gqc","year":"zpbVB","skeleton-progress":"EfQcF"};